/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Step_2_DescInputs */

const en_mk_desktop_step_2_desc = /** @type {(inputs: Mk_Desktop_Step_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under “Your agents”, select Sign in. Follow the provider’s official process with your own account.`)
};

const id_mk_desktop_step_2_desc = /** @type {(inputs: Mk_Desktop_Step_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pada “Agent milikmu”, pilih Login. Ikuti proses resmi penyedia menggunakan akunmu sendiri.`)
};

/**
* | output |
* | --- |
* | "Under “Your agents”, select Sign in. Follow the provider’s official process with your own account." |
*
* @param {Mk_Desktop_Step_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_step_2_desc = /** @type {((inputs?: Mk_Desktop_Step_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Step_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_step_2_desc(inputs)
	return en_mk_desktop_step_2_desc(inputs)
});